/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { ErrorState } from '../../../components/states';
import { DataGrid } from '../../../components/datagrid';
import { SearchFilter } from '../../../components/inputs/filters/search';
import { PageTitle } from '../../../components/PageTitle';
import { useFetch } from '../../../hooks/useFetch';
import { ReturnButton } from '../../../components/buttons/ReturnButton';
import Loader from '../../../components/Loader';
import { useAuth } from '../../../providers/auth';

export function TeamStudentsPage() {
  const { institutionId, teamId } = useParams();
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/children?team_id=${teamId}`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const groupIds = user?.group?.id;

  const {
    requestApi: reqApiTeam,
    data: dataTeam,
    loading: loadingTeam,
    error: errorTeam,
  } = useFetch('/v1/admin/teams');

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Nome' },
    { name: 'birth_date', label: 'Data de nascimento' },
    { name: 'parents', label: 'Responsáveis' },
  ];

  useEffect(() => {
    reqApiTeam('get', null, `/v1/admin/teams/${teamId}`);
  }, [teamId]);

  if (loadingTeam) {
    return <Loader />;
  }

  if (errorTeam) {
    return <ErrorState onRetry={() => reqApiTeam('get', null, `/v1/admin/teams/${teamId}`)} />;
  }

  return (
    <Box>
      <Flex>
        <ReturnButton previousPage={`institutions/list/${institutionId}/teams`} mb={5} />
        <PageTitle>Alunos da turma {dataTeam?.data?.name}</PageTitle>
      </Flex>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        rowActions={{ show: groupIds === 3, edit: true, delete: groupIds !== 3 }}
        formatColum={[
          {
            field: 'birth_date',
            formatField: (value) => (value ? moment(value).format('DD/MM/yyyy') : 'Não informado'),
          },
          {
            field: 'parents',
            formatField: (value) =>
              value.length > 0 ? (
                <Text>{value.map((item) => item.name).join(', ')}</Text>
              ) : (
                'Não informado'
              ),
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
